import React from 'react';
import { FiList, FiEdit3, FiCheckCircle, FiEye } from 'react-icons/fi';
import { Badge } from '@/components/ui/badge';
import { MODALITY_LABEL, ETAPA_LABEL } from '@/components/custom/question/question-detail-content';

const MODALITY_ICON = {
  multiple_choice: FiList,
  discursive: FiEdit3,
  essay: FiEdit3,
  true_false: FiCheckCircle,
  short_answer: FiEdit3
};

// Mesma heurística de QuestionsList.jsx (default) e question-detail-content.jsx
// pra achar a matéria dentro das taxonomies (matéria + descritor SAEB + sub-conteúdos).
const MATERIAS = new Set(['Matemática', 'Língua Portuguesa', 'Lingua Portuguesa']);

function truncate(text = '', n = 110) {
  const clean = String(text)
    .replace(/<[^>]+>/g, '')
    .trim();
  return clean.length > n ? `${clean.slice(0, n - 1)}…` : clean;
}

// Card somente leitura: sem edição/exclusão/duplicação nesta fase (spec
// docs/superpowers/specs/2026-08-22-playful-teacher-questoes-design.md).
export function QuestionRowTeacher({ question, index = 0, onView }) {
  const a = question.attributes || {};
  const taxs = a.taxonomies || [];
  const materia = taxs.find(t => MATERIAS.has(t.name))?.name;
  const codigo = a['external-id'] || a.code || `#${question.id}`;
  const ModalityIcon = MODALITY_ICON[a.modality];

  return (
    <div
      className="flex flex-wrap items-center gap-4 rounded-[16px] border border-neutral-100 bg-white p-4 shadow-card transition-shadow duration-150 hover:shadow-card-hover"
      style={{ animation: `trilha-in 380ms cubic-bezier(0.23, 1, 0.32, 1) ${250 + index * 70}ms both` }}
      data-testid="question-row-teacher"
      data-code={codigo}
    >
      <div className="min-w-[200px] flex-1">
        <div className="flex flex-wrap items-center gap-2">
          {a.etapa && <Badge variant="info-soft">{ETAPA_LABEL[a.etapa] || a.etapa}</Badge>}
          {materia && (
            <Badge
              variant="muted"
              className="text-neutral-700"
            >
              {materia}
            </Badge>
          )}
          <span className="ml-auto text-xs font-semibold text-neutral-600">{codigo}</span>
        </div>

        <p
          className="mb-0 mt-2 line-clamp-2 text-base font-extrabold leading-snug"
          style={{ color: '#222731' }}
          title={a.description}
        >
          {truncate(a.description)}
        </p>

        <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm font-semibold text-neutral-600">
          {ModalityIcon && (
            <span className="flex items-center gap-1.5">
              <ModalityIcon className="h-4 w-4 text-mission" />
              {MODALITY_LABEL[a.modality] || a.modality}
            </span>
          )}
        </div>
      </div>

      <button
        type="button"
        onClick={() => onView?.(question)}
        className="hover:border-[var(--color-mission)]/40 inline-flex shrink-0 items-center gap-1.5 self-start rounded-full border border-neutral-100 px-3 py-1.5 text-sm font-semibold text-neutral-600 transition-colors duration-150 hover:text-[var(--color-mission)]"
      >
        <FiEye className="h-4 w-4" />
        Ver
      </button>
    </div>
  );
}
